<template>
    <div class="loadding-component">
        <div class="loadding-component-box">
            <van-loading color="#999" text-color="#999" :vertical="true">加载中...</van-loading>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
        },
    }
}
</script>
<style scoped>
.loadding-component {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.loadding-component-box {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
